<template>
  <div class="bg-main">
    <div
      v-if="hasSiteWideMessage"
      class="text-size-chart text-center relative flex justify-center items-center h-32 bg-primary text-white z-sidebar-overlay "
    >
      <div v-html="config.siteWideMessage" />
      <div
        class="
          absolute
          md:right-24
          right-16
          text-white
          select-none
          cursor-pointer
        "
        @click="hideSiteWideMessage"
      >
        <fa :icon="['fal', 'times']" />
      </div>
    </div>
    <div
      v-else-if="siteUsps.length > 0"
      class="relative bg-white flex md:justify-center justify-around items-center h-32 z-sidebar-overlay
      text-size-chart text-center text-muted
      border-b border-b-black-25"
    >
      <div
        v-for="usp in siteUsps"
        :key="'site-usp-' + usp.usp"
        class="md:mr-18 md:last:mr-0"
      >
        <fa class="text-xs mr-6" :icon="['fal', 'check']" />
        {{ usp.usp }}
      </div>
    </div>
    <div
      class="relative z-header bg-main h-header-desktop border-b border-border"
    >
      <div
        class="container xxl:px-24 h-full flex items-center bg-main justify-between "
      >
        <div v-if="!uiStore.isMobile" class="w-2/5 h-full flex items-center">
          <div
            v-if="isCheckout"
            class="cursor-pointer select-none py-16 max-w-208"
            @click="$router.back()"
          >
            <fa :icon="['fal', 'chevron-left']" />
            <span v-if="!uiStore.isMobile">
              {{ $lang('checkout', 'header_back_btn') }}
            </span>
          </div>
          <div v-else class="flex h-full items-center">
            <div v-if="!uiStore.isMobile" class="flex h-full">
              <div
                class="flex relative items-center text-black-full cursor-pointer select-none mr-8 pr-16 "
                @click="toggleFlyoutMenu"
              >
                <img
                  src="~/assets/icons/menu.png"
                  class="h-24 w-24 mr-8"
                  width="24"
                  height="24"
                  alt="menu icon"
                >
                {{ $lang('header', 'menu') }}
              </div>
              <nuxt-link
                v-for="link in navigation"
                :key="link.title"
                :to="link.url || homeUrl"
              >
                <div
                  :ref="link.title"
                  class="
                    flex
                    relative
                    h-full
                    items-center
                    text-black-full
                    cursor-pointer
                    select-none
                    mr-8
                  "
                  @mouseenter="enterMenuBtn(link.children, link.title)"
                  @mouseleave="leaveMenuBtn"
                >
                  <div
                    class="
                      md:hover:bg-white
                      px-16
                      py-12
                      rounded-3xl
                      md:hover:underline
                    "
                    :class="{
                      'md:bg-white md:underline':
                        openMenuLink === link.title && !uiStore.isMobile,
                    }"
                  >
                    {{ link.title }}
                  </div>
                  <transition name="fade">
                    <div
                      v-if="menuOpen && openMenuLink === link.title"
                      class="
                        absolute
                        bottom-0
                        bg-black-full bg-opacity-25
                        z-below
                      "
                      :style="`left: -15px`"
                      @click.self="closeMenu"
                    >
                      <transition :name="transitionName">
                        <div
                          v-if="showContent"
                          class="
                            fixed
                            top-0
                            bottom-0
                            w-240
                            md:pr-0 md:top-auto md:bottom-auto
                          "
                        >
                          <div
                            class="bg-white overflow-auto p-24 drop-down-menu rounded-xl max-h-540 "
                            @mouseenter="hoveringOnSubMenu"
                            @mouseleave="leavingSubMenu"
                          >
                            <div
                              v-if="uiStore.isMobile"
                              class="px-24 py-28 uppercase flex justify-between items-center "
                            >
                              <fa
                                class="cursor-pointer text-md select-none"
                                :icon="['fal', 'times']"
                                @click="closeMenu"
                              />
                            </div>
                            <div v-if="!uiStore.isMobile" class="flex flex-col h-full">
                              <div
                                v-for="(subLink, idx) in subLinks"
                                :key="
                                  subLink.title
                                    ? subLink.title
                                    : link.title + subLink.type + idx
                                "
                                class="h-full w-full mb-24 last:mb-0"
                              >
                                <nuxt-link
                                  v-if="subLink.type === 'link'"
                                  :to="subLink.url"
                                >
                                  <div
                                    class="flex items-center text-grey md:hover:underline md:hover:text-black-full"
                                  >
                                    <img
                                      v-if="subLink.icon"
                                      :src="subLink.icon"
                                      class="rounded-full h-32 w-32 mr-12"
                                      width="32"
                                      height="32"
                                      alt="menu icon"
                                    >
                                    {{ subLink.title }}
                                  </div>
                                </nuxt-link>
                                <div
                                  v-else-if="subLink.type === 'divider'"
                                  class="border-b"
                                />
                              </div>
                            </div>
                          </div>
                        </div>
                      </transition>
                    </div>
                  </transition>
                </div>
              </nuxt-link>
            </div>
          </div>
        </div>
        <div class="w-2/5 flex md:justify-center">
          <nuxt-link :to="homeUrl">
            <img
              src="~/assets/images/header-logo.png"
              class="md:h-24 w-auto"
              alt="Ullmax-logga"
              height="24"
              width="102"
            >
          </nuxt-link>
        </div>
        <div class="w-2/5 flex justify-end">
          <div v-if="!isCheckout" class="flex">
            <div
              class="
                flex
                text-black-full
                md:mr-32
                mr-24
                cursor-pointer
                select-none
              "
              @click="toggleSearchMenu()"
            >
              <img
                src="~/assets/icons/search.png"
                class="h-24 w-24 mr-8"
                width="24"
                height="24"
                alt="search icon"
              >
              <div v-if="!uiStore.isMobile" class="inline-block">
                {{ $lang('header', 'search') }}
              </div>
            </div>
            <div
              class="cart-button text-black-full cursor-pointer select-none"
              :class="{
                'mr-24': uiStore.isMobile,
              }"
              @click="toggleCartMenu"
            >
              <button class="flex relative items-center" @click="cartStore.showCartMenu = true">
                <img
                  src="~/assets/icons/shopping-bag.png"
                  class="h-24 w-24 mr-8"
                  width="24"
                  height="24"
                  alt="cart icon"
                >
                <div v-if="!uiStore.isMobile" class="inline-block">
                  {{ $lang('header', 'cart') }}
                </div>
                <transition name="appear">
                  <div
                    v-if="cartProductCount"
                    class="rounded-full text-white text-tiny bg-black-full flex items-center justify-center border border-white "
                    :class="{
                      'items-badge h-20 w-20 absolute rounded-lg': uiStore.isMobile,
                      'h-20 w-20 ml-8': !uiStore.isMobile,
                    }"
                  >
                    {{ cartProductCount }}
                  </div>
                </transition>
              </button>
            </div>
            <div
              v-if="uiStore.isMobile"
              class="flex relative items-center text-black-full cursor-pointer select-none"
              @click="toggleFlyoutMenu"
            >
              <img
                src="~/assets/icons/menu.png"
                class="h-24 w-24"
                width="24"
                height="24"
                alt="menu icon"
              >
            </div>
          </div>
        </div>
      </div>
    </div>
    <!--    <ClubAndSeller />-->
    <client-only>
      <transition name="fade-slide-top" mode="out-in">
        <div
          v-if="showSiteErrorMessage"
          class="top-0 right-0 left-0 flex justify-between items-center h-32 bg-warning text-white z-site-error "
          :class="{
            fixed: isCheckout,
            absolute: !isCheckout,
          }"
        >
          <div class="ml-24">{{ uiStore.tempErrorMsg }}</div>
          <div class="mr-24">
            <button @click="uiStore.tempErrorMsg = ''">
              <img
                src="/icons/close-inv.svg"
                class="h-18 relative top-2"
                alt="close"
              >
            </button>
          </div>
        </div>
      </transition>
    </client-only>

    <FlyoutMenu
      v-if="flyoutMenuToggled"
      :links="flyOutNavigation"
      :is-mobile="uiStore.isMobile"
      @on-flyout-menu-close="toggleFlyoutMenu"
    />
    <CartMenu v-if="cartStore.showCartMenu" />

    <SideSearch v-if="searchMenuToggled" @on-search-close="toggleSearchMenu" />
    <ItemAdded v-if="cartStore.showAddedItem" />
  </div>
</template>

<script setup lang="ts">
import { useUiStore } from '~/store/ui';
import { useConfigStore } from '~/store/config';
import type { NavigationType } from '~/constants/types/navigation';

import FlyoutMenu from '~/components/navigation/FlyoutMenu.vue';
import { useCartStore } from '~/store/cart';
import ItemAdded from '~/components/cart/ItemAdded.vue';
import CartMenu from '~/components/cart/CartMenu.vue';
import SideSearch from '~/components/search/SideSearch.vue';
import ClubAndSeller from '~/components/body/ClubAndSeller.vue';
const config = useConfigStore();
const uiStore = useUiStore();
const cartStore = useCartStore();

defineProps<{
  scrolled?: boolean,
  isCheckout?: boolean,
}>();

const emit = defineEmits<{
  (e: 'hideSiteWideMessage'): void;
}>();

const menuOpen = ref(false);
const showContent = ref(false);
const openMenuLink = ref<string | null>(null);
const subLinks = ref<NavigationType[]>([]);
const menuOffset = ref(0);
const onSubMenu = ref(false);
const timeout = ref<any>(null);
const switchingTimeout = ref<any>(null);

const flyoutMenuToggled = ref(false);
const searchMenuToggled = ref(false);
const cartMenuToggled = ref(false);

const siteWideMessage = computed<string>(()=> {
  return config.siteWideMessage || '';
});

const siteUsps = computed<{ usp:string }[]>(()=> {
  return config.usps || [];
});

const navigation = computed<NavigationType[]>(()=> {
  return config.navigation.primary_navigation;
});

const homeUrl = computed<string>(()=> {
  return config.home_url;
});

const flyOutNavigation = computed<NavigationType[]>(()=> {
  return config.navigation.flyout_navigation;
});

const cartProductCount = computed<number>(()=> {
  return cartStore.cartData.totalItemQuantity || 0;
});

const transitionName = computed<string>(()=> {
  if (uiStore.isMobile) {
    return 'slide-right';
  }
  return 'slide';
});

const showSiteErrorMessage = computed(()=> {
  return (uiStore.tempErrorMsg && uiStore.tempErrorMsg !== '');
});

const openMenu = (children: NavigationType[], menuLink: string) => {
  /*const el = this.$refs[menuLink] as Element[];
  this.menuOffset = -120 + el[0].getBoundingClientRect().width / 2;*/
  menuOpen.value = true;
  setActiveMenuLinks(children, menuLink);
  setTimeout(() => (showContent.value = true), 2);
};

const setActiveMenuLinks = (children: NavigationType[], menuLink: string) => {
  openMenuLink.value = null;
  subLinks.value = children;
  openMenuLink.value = menuLink;
};

const unsetActiveMenuLinks = () => {
  subLinks.value = [];
  openMenuLink.value = null;
  timeout.value = setTimeout(() => {
    menuOffset.value = 0;
  }, 100);
};

const enterMenuBtn = (children: NavigationType[], menuLink: string) => {
  clearTimeout(timeout.value);
  if (children.length) {
    if (!menuOpen.value) {
      openMenu(children, menuLink);
    } else {
      menuOpen.value = true;
      if (switchingTimeout.value) {
        clearTimeout(switchingTimeout.value);
        switchingTimeout.value = null;
      }
      switchingTimeout.value = setTimeout(() => {
        /**
         * @todo - i have no idea what this is supposed to do, but since refs works different in nuxt 3,
         * i've turned it off
         */
        /*const el = $refs[menuLink].value as Element[];
        menuOffset.value = -120 + el[0].getBoundingClientRect().width / 2;
*/
        setActiveMenuLinks(children, menuLink);
      }, 350);
    }
  } else if (menuOpen.value) {
    timeout.value = setTimeout(() => closeMenu(), 100);
  }
};

const leaveMenuBtn = () => {
  timeout.value = setTimeout(() => closeMenu(), 100);
};

const hoveringOnSubMenu = () => {
  clearTimeout(timeout.value);
  if (switchingTimeout.value) {
    clearTimeout(switchingTimeout.value);
    switchingTimeout.value = null;
  }
  onSubMenu.value = true;
};

const leavingSubMenu = () => {
  if (!uiStore.isMobile) {
    onSubMenu.value = false;
    timeout.value = setTimeout(() => closeMenu(), 100);
  }
};

const closeMenu = () => {
  showContent.value = false;
  unsetActiveMenuLinks();
  document.body.classList.remove('locked');
  setTimeout(() => (menuOpen.value = false), 2);
};

const toggleFlyoutMenu = () => {
  flyoutMenuToggled.value = !flyoutMenuToggled.value;
};

const toggleSearchMenu = () => {
  searchMenuToggled.value = !searchMenuToggled.value;
};

const toggleCartMenu = () => {
  cartMenuToggled.value = !cartMenuToggled.value;
};

// Site wide message
const isSiteMessageHiddenCookie = useCookie('isSiteMessageHidden', { maxAge: 3600 * 24 * 7, path: '/' });
const hasSiteWideMessage = computed(()=> {
  return config.siteWideMessage && config.siteWideMessage !== '' && isSiteMessageHiddenCookie.value !== 'true';
});
const hideSiteWideMessage = () => {
  isSiteMessageHiddenCookie.value = 'true';
};

</script>

<style scoped lang="postcss">
.drop-down-menu {
  box-shadow: 0 4px 24px #00000029;
}
.items-badge {
  bottom: 15px;
  left: 12px;
}
</style>
